import { render, staticRenderFns } from "./ProdutosItens.vue?vue&type=template&id=4e404bfb&scoped=true&"
import script from "./ProdutosItens.vue?vue&type=script&lang=js&"
export * from "./ProdutosItens.vue?vue&type=script&lang=js&"
import style0 from "./ProdutosItens.vue?vue&type=style&index=0&id=4e404bfb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e404bfb",
  null
  
)

export default component.exports